import axios from 'axios';
import { API_URL } from '../config';
import type { LoginResponse, MeResponse } from '../types/auth';

// Auth requests use a separate axios instance (NO X-Api-Key header). Real-firm
// panels authenticate via /api/auth/login → JWT, then attach Bearer token to
// subsequent requests via the main apiClient interceptor.
const authClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const { data } = await authClient.post<LoginResponse>('/api/auth/login', {
      email,
      password,
    });
    return data;
  },

  getMe: async (token: string): Promise<MeResponse> => {
    const { data } = await authClient.get<MeResponse>('/api/auth/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  },
};
